import React from 'react';

function PrivacyText({ privacy, children }) {
  return <span className={privacy ? 'privacy-text' : ''}>{children}</span>;
}

export default PrivacyText;
